var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 20.113,
    viewBox: "0 0 32 20.113",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Hide",
    transform: "translate(1 1.414)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6787",
    "data-name": "Path 6787",
    d: "M33.786,16.516s-6.716,8.054-15,8.054-15-8.054-15-8.054,6.716-8.054,15-8.054S33.786,16.516,33.786,16.516Z",
    transform: "translate(-3.786 -7.286)",
    fill: "none",
    stroke: "#677991",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_110",
    "data-name": "Ellipse 110",
    cx: 5.94,
    cy: 5.651,
    rx: 5.94,
    ry: 5.651,
    transform: "translate(9.008 3.624)",
    fill: "none",
    stroke: "#677991",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1576",
    "data-name": "Group 1576",
    transform: "translate(6.168)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6796",
    "data-name": "Path 6796",
    d: "M14.495,6.273l4.518,4.662,7.651,7.895,4.581,4.728",
    transform: "translate(-14.495 -6.273)",
    fill: "none",
    stroke: "#677991",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeHide);
export default __webpack_public_path__ + "static/media/eye-hide.0ce3f7e0d43ecea8be810f159085d3a4.svg";
export { ForwardRef as ReactComponent };